import type { CarouselProps } from '#ui/types';
import { computed } from 'vue';

export type UseStoryblokCarouselUiReturnType = ComputedRef<CarouselProps['ui']>;

export const useStoryblokCarouselCarouselUi = (itemsPerPage: MaybeRefOrGetter<'1' | '2' | '3' | '4'>): UseStoryblokCarouselUiReturnType => {
    return computed(() => {
        const ui: CarouselProps['ui'] = { container: 'm-1' };

        switch (toValue(itemsPerPage)) {
            case '2':
                ui.item = 'md:basis-1/2';
                break;
            case '3':
                ui.item = 'md:basis-1/2 lg:basis-1/3';
                break;
            case '4':
                ui.item = 'md:basis-1/2 lg:basis-1/4';
                break;
        }

        return ui;
    });
};
